import * as React from 'react';
/**
 *
 * Original name: Twitter
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=9980%3A610
 *
 */
export const TwitterExternalLogo = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { d: "M9.026 18.51c6.038 0 9.341-5.007 9.341-9.341 0-.141 0-.282-.006-.423A6.689 6.689 0 0 0 20 7.043a6.654 6.654 0 0 1-1.889.519 3.303 3.303 0 0 0 1.447-1.819 6.53 6.53 0 0 1-2.087.794A3.277 3.277 0 0 0 15.076 5.5a3.287 3.287 0 0 0-3.284 3.285c0 .256.032.505.083.749a9.323 9.323 0 0 1-6.767-3.432 3.292 3.292 0 0 0 1.018 4.386 3.32 3.32 0 0 1-1.486-.41v.045a3.29 3.29 0 0 0 2.632 3.22 3.198 3.198 0 0 1-.865.115c-.21 0-.416-.019-.614-.057a3.283 3.283 0 0 0 3.067 2.28 6.585 6.585 0 0 1-4.079 1.408A6.32 6.32 0 0 1 4 17.044a9.339 9.339 0 0 0 5.026 1.466Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
